import ProductTile from './product-tile'

export default ProductTile
